<template lang="pug">

// todo date language
v-layout(column key="termin")

  v-flex(xs12 text-center).mt-2
    h1.display-3.aiwsibg Termin buchen

  v-flex(xs12).mt-5
    v-expansion-panels(v-model="termtype").typeselect
      v-expansion-panel(v-for="(type, i) in $store.state.termintypes" :key="type.name").mt-1.mb-1
        v-expansion-panel-header {{type.name}}
        //- v-expand-transition
        v-expansion-panel-content
          p.mb-0.mt-4 {{type.desc}}

  v-expand-transition
    v-flex(v-show="termtype !== 4 && termtype !== undefined")
      v-container
        v-row
          v-col
            v-dialog(ref="datedialog" width="290px" v-model="datemodal" :return-value.sync="date")
              template(v-slot:activator="{ on }")
                v-text-field(
                  v-model="formattedDate"
                  label="Datum"
                  prepend-icon="event"
                  @click:prepend="datemodal = true"
                  @focus="datemodal = true"
                  readonly
                  v-on="on"
                )
              v-date-picker(v-model="date" color="primary" :allowed-dates="allowedDates").tester
                v-spacer
                v-btn(text color="primary" @click="datemodal = false") Abbrechen
                v-btn(text color="primary" @click="$refs.datedialog.save(date)") OK
          v-col
            v-select(:items="daytimes" label="Zeit" @change="setDaytime" v-model="seldaytime")
              template(v-slot:item="{ item }")
                div.daytime(v-html="item")
              template(v-slot:selection="{ item }")
                div.daytimeselection(v-html="item")
        v-row
          v-col
            v-btn(block color="primary" :disabled="!(!isNaN(termtype) && seldaytime && date)" @click="next") Weiter

  v-expand-transition
    v-flex(v-show="termtype === 4")
      v-simple-table.saunatable.elevation-2.mt-4
        thead
          tr
            th Saunazeiten
        tbody
          tr
            td.day Montag
            td 10:00 - 12:00 Uhr</br>16:00 - 19:30 Uhr <span>(Frauensauna)</span></br>19:30 - 21:15 Uhr
          tr
            td.day Dienstag
            td 10:00 - 13:00 Uhr</br>17:00 - 21:15 Uhr
          tr
            td.day Mittwoch
            td 17:00 - 21:15 Uhr
          tr
            td.day Donnerstag
            td 17:00 - 21:15 Uhr
          tr
            td.day Freitag
            td 17:00 - 21:15 Uhr
          tr
            td.day Samstag
            td 09:00 - 12:30 Uhr
          tr
            td.day Sonntag
            td 12:00 - 14:45 Uhr
</template>

<script>
export default {
  name: "termin",
  data: () => ({
    datemodal: false,
    date: undefined,
    daytime: undefined,
    termtype: undefined,
    seldaytime: undefined,
    daytimes: [
      "vormittags <span>(08:30 - 12:00 Uhr)</span>",
      "nachmittags <span>(12:00 - 16:00 Uhr)</span>",
      "abends <span>(16:00 - 21:00 Uhr)</span>",
    ],
  }),
  mounted() {
    window.term = this
    if (this.$store.state.pendingAuth) {
      localStorage.clear()
      location.reload()
    }
    const { daytime, date, termtype } = this.$store.state
    if (!isNaN(daytime) && date && !isNaN(termtype)) {
      this.termtype = termtype
      this.date = date
      this.seldaytime = this.daytimes[daytime]
      this.daytime = daytime
    }
  },
  computed: {
    formattedDate() {
      if (!this.date) return null

      const [year, month, day] = this.date.split("-")
      return `${day}. ${this.$store.state.months[Number(month) - 1]} ${year}`
    },
  },
  methods: {
    setDaytime(d) {
      this.daytime = this.daytimes.indexOf(d)
    },
    allowedDates: v =>
      +new Date(v) > +new Date() &&
      +new Date(v) < new Date().setDate(new Date().getDate() + 14),
    next() {
      const { daytime, date, termtype } = this
      this.$store.commit("setData", { daytime, date, termtype })
      this.$router.replace("/buchen")
    },
  },
}
</script>

<style lang="stylus">
.typeselect
  .v-expansion-panel-header
    background: #474754
    color: #fff

  .v-expansion-panel-header--active
    background: #00a3cc

  .v-expansion-panel--active .v-expansion-panel-content
    background: #fff
    color: #212121

.theme--dark.v-application .theme--dark.v-picker__body
  background: #33333d

.saunatable.v-data-table
  th
    font-size: 1.25em

  td.day
    width: 45%

  span
    font-size: 0.75em
    opacity: 0.75

.daytime span
  font-size: 0.75em
  opacity: 0.75

.daytimeselection span
  display: none
</style>